module.exports = __webpack_public_path__ + "img/ip-karten_01.7b95206d.jpg";